import React, { useEffect, useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SignatureForm from './SignatureForm'
import FeedbackForm from './FeedbackForm'
import * as rest from '../../services'
import './style.css'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import Slider from '../Users/Slider'
import { Terms } from '../../components/prints/utils'
import { isMobileDevice } from '../../helpers'
import { Tab, Tabs } from 'react-bootstrap'
import {
  DeliveryPrintReport,
  LoanerDeviceAgreementPrint,
  TicketPrintReport,
  VoucherPrint,
} from '../Tickets/prints'
import {Loading, PrintHOC} from '../../components'

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

export const ESignature = (props) => {
  const { clientName } = useSelector((state) => state.application)

  const terms = [
    'The  Customer  is  requested  to  receive  the  Service  Report via email  when  the  product  is  given  for  ' +
      'warranty/Out  of Warranty  repairs  at  Apple  Authorized  Service  Provider  (AASP)  and  the  Customer  must ' +
      ' verify  the  contents  of the Service Report before signature.',

    'Once you handover the Device to Service centre,  it will be deemed that you have given your consent to  ' +
      'Service Centre(s) to approach you and send communication/information to you regarding this services through ' +
      'call/SMS/email',

    'The  Customer  must  produce  the  Original  Service  Report over the registered mail at the time of taking the ' +
      `delivery. ${clientName} reserves the right to refuse delivery upon non production of the ' +
      'service report.`,

    `Physically damaged and liquid spilled  products if  received by ${clientName}  will  be  ` +
      'considered  as  Out  Of  Warranty  and  will  be  repaired/replaced  on a chargeable  basis & ' +
      `${clientName}  will  not  be  responsible  for  those  accidental  physical/liquid  ` +
      'damaged  parts/units  to  be  unresponsive during the diagnosing procedure.',

    'Any  kind  of  tampering/Unauthorized  modification  if  found  within  the  device,  the  service centre  ' +
      'reserves  the right to decline service for the same. Inspection/Diagnosis fee would be as applicable for ' +
      'such cases.',

    'You are advised to take data backup before handing over Device to the service centre or pick up agent. ' +
      'The Service Centre will not be responsible for any data loss during this service or repair. ' +
      `No claims of any sort shall be entertained against ${clientName}  Service Centre(s) ` +
      'with regard to data loss.',

    'You are advised to format the Device and also remove SIM card before handing it over to the Agent for ' +
      'service/repair. You are advised to turn off the FMI (Find my iPhone / Find my Mac) from your device' +
      ' before handing it over for service/repair.',

    'The  replacement  (if  applicable)  IOS  unit  offered  in  warranty/out  of  warranty  will  be  a ' +
      ' like  to  like  unit  replacement  only.  (i.e.  without  Box  Pack, accessories, Scratch  ' +
      'Guard  &  personal  engraving)  &  the  same  replaced  unit  or  the  replaced  spare  will ' +
      ' have  a  90  days  warranty  if  the  unit/device  is  out  of  warranty.  ' +
      'The  request once placed for spares (for the required repair) OR Unit replacement for ' +
      'IOS device if applicable shall not be cancelled.',

    'The  service  Centre  shall  take  utmost  care  while  handling  the  units  given  for  repair/service, ' +
      ' however  in  the event of any cosmetic issues service centre shall not be responsible for the same.',

    'The  charge  for  labour  as  well  as  spares  used  for  non-warranty  repair  shall  be  as  per  ' +
      'the  applicable  price  lists approved  and  recommended  by  Apple.  ' +
      'The  defective  parts  replaced  while  undertaking  the  repairs  of  the product under warranty ' +
      'will not be returned to the Customer.',

    `${clientName}   shall  make  all  efforts  to  ensure  that  the  product  is  repaired  within` +
      '  5  working days from the receipt of faulty product. At times however, due to non-availability/shortage of ' +
      'critical spares/  parts  or  complicated  fault,  the  repair  turn  around  time  may  take  longer  than ' +
      `indicated  while  accepting  the  machine  for  repair.  ${clientName}   will  not  be ` +
      ' responsible  for  any  loss/losses  whatsoever  in  the event of the delay in repair for such ' +
      'aforementioned reason.',

    `${clientName}   is  not  liable  for  any  delays,  non-performance, ` +
      ' failure  or  non-delivery  of  the  product  due  to  contingencies  arising  from  any  force ' +
      ' measure,  natural  calamities  like  storm,  earthquake,  accident  etc.  strikes,  lockout, ' +
      ' industrial  disputes,  labour  trouble,  transportations  embargo,  imminence  or  the  existence  of  any  ' +
      'state  emergency,  war,  civil  commotion  right,  communal  riots,  approval  or  imposition  of  ' +
      'sanctions  or  any  measure  taken  by  government  which  renders  it  impossible  or  impractical  ' +
      `for  ${clientName}  to perform supply, service or deliver the product to the customer.`,

    'The Estimate price given at the time of acceptance of the Product to repair is provisional and may vary after  ' +
      `detailed inspection and could be more than the final charges. ${clientName}  will proceed only ` +
      ' after taking the approval of the customer & payment confirmation.',

    'In the event the customer does not approve the final repair estimate within 7 days, the ' +
      'customer is requested  to have the device collected from the service centre at the earliest.',

    'The customer should take the delivery of the product within 30 days from the date after repair is completed ' +
      ' OR  Awaiting  Customer’s  Approval.  In  the  event  if  the  delivery  is  not  taken  by  the  Customer,  ' +
      `${clientName}  reserves the right to dispose/scrap the product to recover the repair/storage` +
      ' charges.',

    'Software based issues will be repaired on chargeable basis upon customer’s approval. By  accepting  ' +
      'the  service  report,  it  is  deemed  that  the Customer  agrees  to  all  the terms  and  ' +
      'condition  in  the  Service Report.',

    'Service Charges (Handling/ Inspection/Troubleshoot) will be Applicable for all Apple devices which are ' +
      'Out of Warranty as mentioned below.' +
      'Service Charges for IOS Devices(Watch , iPad, iPhone, Airpods) will be INR 1500/- ( including Taxes)' +
      'Service Charges for MAC Devices will be INR 3000/- (including Taxes)',

    `${clientName}  reserves the right to change/alter/modify/extend/annually modify any ` +
      'terms and conditions mentioned herein at any given point of time at its sole discretion and without any ' +
      'prior notice',

    'All legal matters under Delhi Jurisdiction.',
  ]
  const [success, setSuccess] = useState(null)
  const [errors, setErrors] = useState(null)
  const [showFeedbackForm, setShowFeedbackForm] = useState(false)
  const [message, setMessage] = useState(null)
  const [information, setInformation] = useState(null)
  const dispatch = useDispatch()
  const { height, width } = useWindowDimensions()
  const { type, code, id, guid, url, hideTerms } = props
  const resolveService = () => {
    if (type === 'voucher')
      return `vouchers/${id}/upload_signature2/${code}/${guid}/`
    if (type === 'ticket')
      return `tickets/${id}/upload_signature2/${code}/${guid}/`
    if (type === 'foreign_device_waiver')
      return `tickets/${id}/upload_disclaimer_signature/${code}/${guid}/foreign_device_waiver/`
    if (type === 'iphone_cross_border')
      return `tickets/${id}/upload_disclaimer_signature/${code}/${guid}/iphone_cross_border/`
    if (type === 'watch_release_of_liability')
      return `tickets/${id}/upload_disclaimer_signature/${code}/${guid}/watch_release_of_liability/`
    if (type === 'iphone14_disclaimer')
      return `tickets/${id}/upload_disclaimer_signature/${code}/${guid}/iphone14_disclaimer/`
    if (type === 'delivery')
      return `deliveries/${id}/upload_signature2/${code}/${guid}/`
    if (type === 'loaner_record')
      return `loanerrecords/${id}/upload_signature2/${code}/${guid}/`
    if (type === 'user') return `${url}upload_signature2/`
  }

    const resolvePostUploadService = () => {
    if (type === 'foreign_device_waiver')
      return `tickets/${id}/update_disclaimer_signature_timestamp/${code}/${guid}/foreign_device_waiver/`
    if (type === 'iphone_cross_border')
      return `tickets/${id}/update_disclaimer_signature_timestamp/${code}/${guid}/iphone_cross_border/`
    if (type === 'watch_release_of_liability')
      return `tickets/${id}/update_disclaimer_signature_timestamp/${code}/${guid}/watch_release_of_liability/`
    if (type === 'iphone14_disclaimer')
      return `tickets/${id}/update_disclaimer_signature_timestamp/${code}/${guid}/iphone14_disclaimer/`
  }

  const resolveServiceForDetails = () => {
    if (type === 'voucher')
      return `vouchers/${id}/get_ticket_details_by_guid/${code}/${guid}/`
    if (type === 'ticket')
      return `tickets/${id}/get_ticket_details_by_guid/${code}/${guid}/`
    if (type === 'delivery')
      return `deliveries/${id}/get_ticket_details_by_guid/${code}/${guid}/`
    if (type === 'loaner_record')
      return `loanerrecords/${id}/get_ticket_details_by_guid/${code}/${guid}/`
    if (type === 'user') return `${url}upload_signature2/`
  }

  const b64toBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1])
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: 'image/jpeg' })
  }
  const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date()
    theBlob.name = fileName
    return theBlob
  }

  const saveSignature = (values) => {
    setSuccess(false)
    setErrors(false)
    const service = resolveService()
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
    rest.RestService.call_url_action(service, 'GET')
      .then((response) => {
        const blob = b64toBlob(values.customer_signature, 'image/png')
        const fileName = 'easeon-signature.png'
        const file = blobToFile(blob, fileName)
        axios.put(response, file, config).then((res) => console.log(res))

        setMessage('Signature saved successfully.')
        setSuccess(true)
        if (type === 'delivery') {
          setShowFeedbackForm(true)
        }


        dispatch(showSuccessToast('Success', 'Signature saved successfully.'))
      }).then(() => {
      if(resolvePostUploadService()){
           rest.RestService.call_url_action(resolvePostUploadService(), 'GET')
        }
    })
      .catch((errors) => {
        setErrors(errors)
        setMessage("Could not save signature.")
      })
  }

  const getInformation = () => {
    rest.RestService.call_url_action(resolveServiceForDetails(), 'GET')
      .then((response) => {
        setInformation(response)
      })
      .catch((errors) => {
        setErrors(errors)
        setMessage('Could not save signature.')
      })
  }
  const saveFeedback = (values) => {
    setSuccess(false)
    setErrors(false)
    const service = `deliveries/${id}/save_feedback/${code}/${guid}`
    rest.RestService.call_url_action(service, 'POST', values)
      .then((response) => {
        setSuccess(response)
        dispatch(showSuccessToast('Success', message))
      })
      .catch((errors) => {
        setErrors(errors)
        setMessage('Could not save Feedback.')
        dispatch(showErrorToast('Error', message))
      })
  }

  return (
    <div
      style={{ width: isMobileDevice ? width : width * 0.5, margin: '0 auto' }}
    >
      {errors && message && (
        <ReactBootstrap.Alert variant="danger" block>
          {message}
        </ReactBootstrap.Alert>
      )}
      {success && message && (
        <ReactBootstrap.Alert variant="success" block>
          {message}
        </ReactBootstrap.Alert>
      )}
      {showFeedbackForm ? (
        <>
          <h2 className="lead ml">
            We want to provide the best experience possible! To help us, please
            take a moment to leave your feedback.
          </h2>
          <div className="p-5">
            <FeedbackForm onSubmit={saveFeedback} />
          </div>
        </>
      ) : (
        <>
          <ReactBootstrap.Col className={'p-2'}>
            <strong>
              {!hideTerms && (
                <>
                  With my signature I accept, and agree to the ${clientName}'s
                  terms and conditions.`
                  <Slider
                    variant="link"
                    title="Terms and conditions "
                    onAfterOpen={getInformation}
                  >
                    <ReactBootstrap.Col>
                      <Tabs
                        defaultActiveKey="info"
                        id="uncontrolled-tab-example-terms"
                        className="mb-3"
                      >
                        <Tab eventKey="info" title="Information">
                          {information && type === 'ticket' && (
                            <TicketPrintReport
                              disableEdit={true}
                              ticket={information}
                            />
                          )}
                          {information && type === 'delivery' && (
                            <DeliveryPrintReport
                              disableEdit={true}
                              ticket={information}
                            />
                          )}
                          {information && type === 'loaner_record' && (
                            <LoanerDeviceAgreementPrint
                              record={information.record}
                              ticket={information.ticket}
                            />
                          )}
                          {information && type === 'voucher' && (
                            <VoucherPrint
                              voucher={information.voucher}
                              ticket={information.ticket}
                            />
                          )}
                          {!information && <Loading />}
                        </Tab>
                        <Tab eventKey="terms" title="Terms">
                          <Terms label="Terms and conditions" value={terms} />
                        </Tab>
                      </Tabs>
                    </ReactBootstrap.Col>
                  </Slider>
                </>
              )}
            </strong>
          </ReactBootstrap.Col>
          <SignatureForm
            hideTerms={hideTerms}
            onSubmit={saveSignature}
            height={height}
            width={width}
            isMobileDevice={isMobileDevice}
          />
        </>
      )}
    </div>
  )
}
